import axiosClient from '../axiosClient';

const uploadAPI = {
    async avatarAPI(data) {
        const url = `/image/upload/400`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },
};

export default uploadAPI;
